<template>
    <span class="text-danger">
        <i
            class="fa fa-trash fa-lg icon-button"
            title="Excluir nota fiscal"
            @click.stop="confirmarExcluirNotaFiscal()"
        ></i>
    </span>
</template>

<script>
export default {
    props: {
        pagamento: {
            type: Object,
            default: () => ({})
        },

        pagamentoNotaFiscal: {
            type: Object,
            default: () => ({})
        },

        pagamentosServicos: {
            type: Object,
            default: () => ({})
        }
    },

    methods: {
        confirmarExcluirNotaFiscal() {
            this.$swal({
                title: 'Exclusão de Nota Fiscal',
                html: `Confirma a exclusão da nota fiscal ${this.pagamentoNotaFiscal.numeroNota}?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    this.excluirNotaFiscal()
                }
            })
        },

        excluirNotaFiscal() {
            this.$store.dispatch('addRequest')
            this.pagamentosServicos
                .excluirNotaFiscal(
                    this.$route.params.pagamentoId,
                    this.pagamentoNotaFiscal.pagamentoNotaFiscalId
                )
                .then(response => {
                    if (response) {
                        if (response.success) {
                            this.$toast.success(
                                'Nota fiscal excluída com sucesso!',
                                'OK',
                                this.$toastConfig.success
                            )
                            this.$emit('obterPagamentoAtualizado')
                        } else {
                            this.$toast.error(
                                response.errors[0],
                                'ERROR',
                                this.$toastConfig.error
                            )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
        }
    }
}
</script>
